<template>
  <div class="pagination">
      <span v-if="lang !== 'D'" class="counter-text">{{$_('you_see')}} {{nNbView}} {{sTypeElement}} {{$_('on')}} {{nNbTotal}}</span>
      <span v-else-if="lang == 'D'" class="counter-text">{{nNbView}} {{$_('on')}} {{nNbTotal}} {{sTypeElement}}</span>
      <div class="progress-bar">
          <span :style="'width:'+getPercent+'%'" class="progress-line"></span>
      </div>
      <button class="btn" v-if="nNbView < nNbTotal" @click="handleEvent">
          <div v-if="loading === false">
            <span>{{$_('load_more')}}</span>
          </div>
          <div v-else>
              <span class="loading"></span>
          </div>
        </button>
  </div>
</template>

<script>
export default {
    data() {
        return {
            nNbTotal: 0,
            loading: false,
            nNumeroPagePrive: 0,
            lang: ""
        }
    },
    props: {
        fn: {
            type: Function
        },
        nInitialStep: {
            type: Number,
            default: 0
        },
        nLimit: {
            type: Number,
            default : 0
        },
        nNumeroPage: {
            type: Number,
            default: 1
        },
        nNombreElementParPage: {
            type: Number,
            default: 20
        },
        nNbElementTotal: {
            type: Number,
            default: 0
        },
        sTypeElement: {
            type: String,
            default: 'éléments'
        }
    },
    computed: {
        getPercent() {
            return (this.nNbView / this.nNbTotal) * 100;
        },
        nNbView() {
            let nNbView = this.nNumeroPagePrive * this.nNombreElementParPage;
            if (this.nNbTotal < nNbView) {
                nNbView = this.nNbTotal;
            }
            return nNbView;
        }
    },
    methods: {

        handleEvent() {

            this.loading = true;

            var data = this.$props.fn(this.nNumeroPagePrive, this.$props.nNombreElementParPage);
            
            data.then(res => {
                this.nNbTotal = res.nNbRecordData
                ++this.nNumeroPagePrive;
                this.loading = false;
            }) 
        }
    },
    mounted() {
        this.nNumeroPagePrive = this.$props.nNumeroPage;
    },
    created() {
      this.nNbTotal = this.$props.nNbElementTotal;

      let userLang = JSON.parse(localStorage.getItem('satabapp-user'));
      this.lang = userLang.lang;
    },
    watch: {
        nNbElementTotal(nValue, nOldValue) {
            this.nNbTotal = nValue;
        }
    }
}
</script>

<style scoped>
.pagination {
    max-width: 300px;
    margin: auto;
    text-align: center
}
.counter-text {
    font-style: italic;
    color: #2A2A2A;
    font-size: var(--fz-md);
    margin-bottom: 20px;
    display: block;
}
.progress-bar {
    width: 200px;
    height: 3px;
    background-color: #BFBFBF;
    margin: 20px auto;
}
.progress-line {
    background-color: #000;
    height: 100%;
    display: block;
    max-width: 100%;
}
button {
    min-width: 150px;
    min-height: 43px;
    border: none;   
}
.loading {
    width: 15px;
    height: 15px;
    border: solid 2px #fff;
    border-radius: 50%;
    display: inline-block;
    border-bottom-color:transparent;
    animation: rotate .6s infinite linear;
}
@keyframes rotate {
    0% {
        transform: rotate(0deg);
    }
    100% {
       transform: rotate(360deg);
    }
}

</style>